import _default from './Sidebar';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Sidebar/index.js
// module id = 1563
// module chunks = 1